"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCreatorsQueryParams = void 0;
var GetCreatorsQueryParams;
(function (GetCreatorsQueryParams) {
    let parts;
    (function (parts) {
        parts["DETAILS"] = "details";
        parts["CHANNELS"] = "channels";
        parts["LABELS"] = "labels";
        parts["SOCIALS"] = "socials";
        parts["AGENCY"] = "agency";
        parts["OUTREACH"] = "outreach";
        parts["SE_FEATURES"] = "seFeatures";
        parts["CONTACT"] = "contact";
        parts["SE_RELATIONSHIP"] = "seRelationship";
        parts["SE_CREATOR_PROGRAMS"] = "seCreatorPrograms";
    })(parts = GetCreatorsQueryParams.parts || (GetCreatorsQueryParams.parts = {}));
})(GetCreatorsQueryParams = exports.GetCreatorsQueryParams || (exports.GetCreatorsQueryParams = {}));
